export const randomTopics = [
    "Is the death penalty ever justified?",
    "Is freedom of speech absolute or are there necessary boundaries?",
    "Can true equality ever be achieved in society?",
    "Is privacy a luxury or a fundamental right in the digital age?",
    "Should genetic engineering be used to design our offspring?",
    "Is there a moral obligation to help the less fortunate?",
    "How do you define 'consciousness' and can machines ever attain it?",
    "Should there be limits to scientific exploration?",
    "Is it ethical to colonize other planets?",
    "Should animals have rights comparable to humans?",
    "Can war ever be justified?",
    "Are there absolute truths or is everything relative?",
    "Do the ends justify the means?",
    "What role should religion play in government?",
    "Is it ever right to sacrifice one for the greater good?",
    "Should humans play God with advancements like CRISPR and AI?",
    "Is censorship ever necessary?",
    "Is there a line between cultural appreciation and cultural appropriation?",
    "Is democracy the best form of governance?",
    "How do you measure the value of a life?",
    "Should we prioritize the planet over economic growth?",
    "Is it ethical to eat animals?",
    "How will future generations judge our actions today?",
    "Is art subjective or are there objective standards of beauty?",
    "Should individuals be allowed to own guns?",
    "To what extent should technology influence our daily lives?",
    "What does it mean to live a good life?",
    "Should we strive for immortality?",
    "Can robots and AI have emotions?",
    "Is universal basic income a solution to poverty or a recipe for laziness?",
    "Is monogamy natural?",
    "Should drugs be decriminalized?",
    "Are humans inherently good or evil?",
    "Is there a moral duty to be environmentally conscious?",
    "Is virtual reality an escape from reality or a new form of it?",
    "Should education be a right or a privilege?",
    "Is there such a thing as objective morality?",
    "What are the consequences of living in a post-truth society?",
    "Is social media a force for good or a source of societal decay?",
    "How does power corrupt?",
    "Should humans modify their bodies with technology?",
    "What is the line between inspiration and plagiarism?",
    "Are we more than the sum of our biology?",
    "Is suffering necessary for personal growth?",
    "How do you define 'freedom'?",
    "What are the implications of living in a surveillance state?",
    "Is nationalism a force for unity or division?",
    "Should we prioritize space exploration over earthly issues?",
    "How do we balance individual rights with societal needs?",
    "Are we heading towards utopia or dystopia?",
    "How do we define the line between human and machine?",
    "Should the pursuit of happiness be a societal goal?",
    "Is anonymity a right in the modern world?",
    "What does 'progress' really mean?",
    "Is there a limit to human potential?",
    "What responsibilities come with great power?",
    "Is there a difference between intelligence and wisdom?",
    "Can true democracy exist in a capitalistic society?",
    "What role does fate play in our lives?",
    "Are our personalities predestined or shaped by experiences?",
    "Is there a price to pay for limitless knowledge?",
    "Should there be boundaries in art?",
    "Is there more value in the journey or the destination?",
    "How do we decide what is 'unnatural'?",
    "Is there ever a justification for censorship in art or media?",
    "Should there be a limit to personal wealth?",
    "How does one define a 'meaningful' life?",
    "Do advancements in technology distance us from our humanity?",
    "What's the role of tradition in a constantly changing world?",
    "Is there ever a right time to forget history?",
    "How does language shape our reality?",
    "Can humanity ever truly achieve a post-racial society?",
    "Does our existence have a purpose?",
    "Should humans seek to conquer nature or live in harmony with it?",
    "Is there a point where freedom of expression becomes harmful?",
    "What is the role of ethics in business?",
    "Is self-interest a virtue or a vice?",
    "Can a person change their nature?",
    "Is there a point where technological integration becomes a loss of self?",
    "Should we value intuition over logic?",
    "Does morality change with culture or is it universal?",
    "What are the ethical implications of creating life in a lab?",
    "Is it more important to be loved or respected?",
    "Do humans have a responsibility to other species?",
    "What does 'identity' mean in a globalized world?",
    "Is the concept of nation-states becoming obsolete?",
    "What are the implications of a cashless society?",
    "Should we place more value on experience or material possessions?",
    "Is there an ethical way to achieve immortality?",
    "How does one differentiate between freedom and chaos?",
    "What role should ethics play in innovation?",
    "Are there dangers in blind optimism?",
    "How does one define 'sanity'?",
    "Is the concept of 'self' an illusion?",
    "Should we control population growth?",
    "What is the role of humanity in the universe?",
    "Is it possible to truly know another person?",
    "Can a society ever be truly meritocratic?",
    "Is there a difference between contentment and happiness?",
    "How do we measure success?",
    "Does absolute power corrupt absolutely?",
    "Is it ethical to live forever if one could?",
    "Can there be unity in diversity?",
    "How do we determine what's 'natural'?",
    "What's the boundary between bravery and foolishness?",
    "Does a perfect society necessitate conformity?",
    "Should the pursuit of knowledge have limits?",
    "Is the universe inherently meaningful or do we give it meaning?",
    "Is our perception of reality limited?",
    "Should human augmentation with technology have limits?",
    "Is the concept of 'good' and 'evil' outdated?",
    "Should nature always be preserved, even at the cost of human needs?",
    "What does 'truth' mean in a subjective world?",
    "What's the price of eternal youth?",
    "Are memories what define us?",
    "Should humanity aim for a hive-mind collective consciousness?",
    "Can one ever be truly selfless?",
    "What does it mean to be 'alive'?",
    "Is competition a driving force for progress or a hindrance?",
    "Can society exist without hierarchies?",
    "How do we define 'love' in modern times?",
    "Does every action have an equal and opposite reaction, even in ethics?",
    "What is the ultimate form of freedom?",
    "Is there a balance between order and chaos?",
    "Can humans ever achieve a utopian society?",
    "How much can one trust their senses?",
    "Is beauty truly in the eye of the beholder?",
    "Should humans try to defy nature or accept it?",
    "What does it mean to be 'human' in a world of AI and genetic modifications?",
    "What are the implications of a world without privacy?",
    "How do we decide what's ethically permissible in science?",
    "Is there a universal standard for ethics?",
    "Do beliefs shape reality or is it the other way around?",
    "Is there an objective 'right' and 'wrong'?",
    "Can individuality coexist with societal harmony?",
    "Is perpetual peace a possibility or a pipe dream?",
    "What are the ethical implications of virtual realities?",
    "Do we have a responsibility to explore space?",
    "Is there a boundary between human rights and national security?",
    "Is there a line between human and God?",
    "Should we value human emotions in decision-making or prioritize logic?",
    "Is there a true self or are we shaped by external factors?",
    "Should there be ethical considerations in storytelling and fiction?",
    "Does the universe favor balance?",
    "How much should past actions dictate present judgment?",
    "Can humans ever be free from biases?",
    "What's the role of luck in success?",
    "Is the idea of destiny just a comforting illusion?",
    "How much control do we truly have over our actions and decisions?",
    "What is the value of a single life?",
    "Is it better to live in blissful ignorance or painful truth?",
    "Is the concept of 'forever' a human construct?",
    "How does one find purpose in a vast universe?",
    "Can humans ever understand the entirety of the universe?",
    "What are the implications of a world driven by algorithms?",
    "Is there a fine line between genius and madness?",
    "What does 'justice' truly mean?",
    "Is change always for the better?",
    "What is the ultimate quest of humanity?",
    "Is a world without emotions a perfect world?"
  ];
